// note: overriding linting to use quick access to local storage for UI preferences
/* eslint-disable no-storage/no-browser-storage */

'use client';

import { isServer } from '@frameio/utils';
import type { ThemeDensity } from '@frameio/vapor';
import { appComponentsStorage } from '../../storage';

const DENSITY_VALUES: ReadonlyArray<ThemeDensity> = [
  'compact',
  'regular',
  'spacious',
] as const;
/**
 * Get the UI density preference from local storage
 * @param fallback - the fallback density to use if local storage is not available
 */
export const getLocalDensityPreference = (
  fallback: ThemeDensity = 'regular'
): ThemeDensity => {
  if (isServer) return fallback;

  try {
    const stored = appComponentsStorage.get('frame-io--ui-density-preference');
    if (stored && DENSITY_VALUES.includes(stored)) {
      return stored;
    }
    return fallback;
  } catch (e) {
    return fallback;
  }
};

/**
 * Set the UI density preference in local storage
 * @param value - the density value to set in local storage
 */
export const setLocalDensityPreference = (value: ThemeDensity): void => {
  if (isServer) return;

  try {
    if (DENSITY_VALUES.includes(value)) {
      appComponentsStorage.set('frame-io--ui-density-preference', value);
    }
  } catch (e) {
    // unsupported
  }
};
